import React, {createContext, useContext} from 'react'
import {useDisclosure} from '@chakra-ui/react'

const AccountModalContext = createContext({})

/**
 * Hook for consuming the shared AccountModal state from context
 */
export const useAccountModal = () => useContext(AccountModalContext)

/**
 * Provider that holds the AccountModal open/close state.
 * Wrap your app (or a subtree) with this so all consumers share the same state.
 */
export const AccountModalProvider = ({children}) => {
    const {isOpen, onOpen, onClose} = useDisclosure()
    return (
        <AccountModalContext.Provider value={{isOpen, onOpen, onClose}}>
            {children}
        </AccountModalContext.Provider>
    )
}
